import { Skeleton } from 'antd';


interface SkeletonListProps {
  customClass?: string
  type?: string
  rows?: number
}

function SkeletonList({ customClass = '', rows = 8 }: SkeletonListProps) {
  return (
    <div className={customClass}>
      <div className='d-flex'>
        <Skeleton active avatar paragraph={{ rows: rows }} />
        <Skeleton active avatar paragraph={{ rows: rows }} />
        <Skeleton active avatar paragraph={{ rows: rows }} />
        <Skeleton active avatar paragraph={{ rows: rows }} />
        <Skeleton active avatar paragraph={{ rows: rows }} />
      </div>
    </div>
  )
}

export default SkeletonList
